import { DashboardPeriod } from "@cpg/common";

import { cn } from "@/lib/utils";

// Segmented control every Phase-4 dashboard tile / period-scoped view
// switches through. Controlled — no internal state beyond the click
// callback.

const OPTIONS: Array<{ value: DashboardPeriod; label: string }> = [
  { value: DashboardPeriod.H24, label: "24h" },
  { value: DashboardPeriod.D7, label: "7d" },
  { value: DashboardPeriod.D30, label: "30d" },
];

export interface PeriodSwitcherProps {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
}

export function PeriodSwitcher({ value, onChange }: PeriodSwitcherProps) {
  return (
    <div className="inline-flex items-center rounded-full border border-border p-0.5">
      {OPTIONS.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            aria-pressed={active}
            className={cn(
              "rounded-full px-3 py-1 text-xs font-medium transition-colors cursor-pointer",
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
